<script setup lang="ts">
import type { ShowcaseContentListItemDto } from '@repo/api/web/models'

import UiPicture from '~/app/components/Image/UiPicture.vue'

const props = defineProps<{
  value: ShowcaseContentListItemDto
  /** Базовый путь детальной страницы ('/news', '/blog') */
  basePath: string
}>()

const { formatDate } = useFormatter()

const href = computed(() => `${props.basePath}/${props.value.slug}`)
const publishedAt = computed(() =>
  props.value.publishAt
    ? formatDate(props.value.publishAt, Formats.DATE_FORMAT)
    : null,
)
</script>

<template>
  <NuxtLink
    :to="href"
    class="group flex flex-col overflow-hidden rounded-2xl border border-neutral-200"
  >
    <UiPicture
      v-if="props.value.coverId"
      :src="props.value.coverId"
      variant="imageFull"
      class="aspect-[16/9] w-full"
      sizes="100vw md:50vw lg:400px"
      loading="lazy"
      :alt="props.value.title"
    />
    <div class="flex flex-1 flex-col gap-2 p-4">
      <time v-if="publishedAt" class="text-xs text-neutral-500">
        {{ publishedAt }}
      </time>
      <h2 class="text-lg font-semibold group-hover:underline">
        {{ props.value.title }}
      </h2>
      <p v-if="props.value.announce" class="line-clamp-3 text-sm text-neutral-600">
        {{ props.value.announce }}
      </p>
    </div>
  </NuxtLink>
</template>
